export const TOOLTIP_KEY = {
    ESCAPE: 'Escape',
    TAB: 'Tab',
};
